import React from "react";
import { Row } from "./Common";
import { Box, Card, CardContent, CardHeader, Grid, Divider, Typography, IconButton, Icon } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";

export function Error(props: { errorMessage?: string }) {
	return (
		<Box my={2} mx={40}>
			<Grid container justify="center" spacing={5}>
				<Grid item xs={12}>
					<Card variant="outlined" className="card-container transperant">
						<CardHeader title={<Typography align="center" variant="h4">Error</Typography>} />
						<Divider variant="middle" />
						<CardContent>
							<Row>
								<Alert severity="error" className="alert error">
									<AlertTitle><strong>Error</strong></AlertTitle>
									{props.errorMessage ?? "Something went wrong....!!"}
								</Alert>
							</Row>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Box>
	);
}


